import Dropzone from 'react-dropzone';
import { useAppDispatch, useAppSelector } from '../../Store/store';
import * as React from 'react';
import { changeToasterState } from '../../Store/layoutSlice';
import { TOASTER_STATE } from '../../Model/Enums';
import { useFileUploadMutation } from '../../Store/file';
import { currentCompanySelector } from '../../Store/paramsBagSlice';

export const FullPageDropZone = ({ children }) => {
  const dispatch = useAppDispatch();
  const currentCompany = useAppSelector(currentCompanySelector);

  const [uploadFile] = useFileUploadMutation();

  const onDropFile = (files: File[]) => {
    const formData = new FormData();
    files.forEach(async (file: File) => {
      formData.append('file', file);
      formData.append('company_name', currentCompany?.name);
      try {
        await uploadFile({ _id: currentCompany?._id, formData }).unwrap();
      } catch (e) {
        dispatch(changeToasterState(TOASTER_STATE.FILE_UPLAOD_FAILED));
      }
    });
  };
  return (
    <Dropzone onDrop={onDropFile} noClick>
      {({ getRootProps, getInputProps }) => (
        <div>
          <div {...getRootProps({})} style={{ cursor: 'default' }}>
            <input {...getInputProps()} />
            {children}
          </div>
        </div>
      )}
    </Dropzone>
  );
};
